/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NegozioDTO } from './negozio-dto';


export interface CassiereDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    attivo?: boolean;
    abilitato?: boolean;
    negozi?: Array<NegozioDTO>;
}

